import React from 'react';
import { Breadcrumb } from 'antd';
import Link from 'next/link';
import { BreadcrumbItem } from '@/lib/types';

interface AppBreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
}

/**
 * 应用面包屑组件
 * 封装了Ant Design的Breadcrumb组件，提供统一的面包屑显示逻辑
 */
const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ items, className }) => {
    // 只有当面包屑项数量大于1时才显示
    if (items.length <= 1) {
        return null;
    }

    return (
        <Breadcrumb
            className={className}
            items={items.map((item, index) => {
                // 对于有href的面包屑项，使用Link组件包装，确保正确跳转
                const titleContent = (
                    <>
                        {/* {item.icon && (
              <span style={{ marginRight: '4px' }}>{item.icon}</span>
            )} */}
                        {item.title}
                    </>
                );

                return {
                    key: index,
                    // 移除直接的href属性，改为在title中使用Link组件
                    title: item.href ? (
                        <Link
                            href={item.href}
                            className="text-blue-600 hover:text-blue-800 transition-colors"
                        >
                            {titleContent}
                        </Link>
                    ) : (
                        titleContent
                    ),
                };
            })}
        />
    );
};

export default AppBreadcrumb;
